import React from 'react';

function FotosessionLinks() {
  return (
    <div>``
      <h1>Photo Session Ideas</h1>
      <ul>
        <li><a href="https://www.instagram.com/matvienko_solomia?igsh=MXU1c2Iya2xtNHBvdA==" target="_blank" rel="noopener noreferrer">Matvienko Solomia</a></li>
        <li><a href="https://www.instagram.com/julia_shmatko?igsh=MTIxcDk3a2prMWNqdA==" target="_blank" rel="noopener noreferrer">Julia Shmatko</a></li>
        <li><a href="https://www.instagram.com/alnovich.photo?igsh=M2JianQ1dnVlM3M4" target="_blank" rel="noopener noreferrer">Alnovich Photo</a></li>
        <li><a href="https://www.instagram.com/alina.kaliina?igsh=c2puaWpmdzY1dDdl" target="_blank" rel="noopener noreferrer">Alina Kaliina</a></li>
        <li><a href="https://www.instagram.com/sofia_levchuk_fotographer?igsh=Y2cwMngzdWp0anJk" target="_blank" rel="noopener noreferrer">Sofia Levchuk</a></li>

      </ul>
    </div>
  );
}

export default FotosessionLinks;